import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './cyber-governance-advisory.css'

const CyberGovernanceAdvisory = (props) => {
  return (
    <div className="cyber-governance-advisory-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="Cyber-Governance-Advisory - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/cyber-governance-advisory"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-governance">
        <div className="hero-governance__media">
          <img
            alt="Cybersecurity data and code on monitor"
            src="https://images.pexels.com/photos/5380664/pexels-photo-5380664.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="hero-governance__image"
          />
          <div className="hero-governance__overlay"></div>
        </div>
        <div className="hero-governance__content-wrapper">
          <div className="hero-governance__content">
            <div className="hero-governance__icon-box">
              <svg
                width="48"
                xmlns="http://www.w3.org/2000/svg"
                height="48"
                viewBox="0 0 24 24"
                className="hero-governance__icon"
              >
                <path
                  d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1zm-8-5v4m0 4h.01"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h1 className="hero-title hero-governance__title">
              Cyber Governance Advisory
            </h1>
            <p className="hero-governance__subtitle hero-subtitle">
              Strategic guidance on security governance frameworks, policy
              architecture, and program maturity. Align security controls with
              business objectives, regulatory mandates, and executive
              accountability.
            </p>
            <div className="hero-governance__actions">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Schedule Strategy Session</span>
                </div>
              </a>
              <a href="#approach">
                <div className="btn btn-lg btn-outline">
                  <span style={{ color: 'black' }}>View Our Approach</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="benefits-governance">
        <div className="benefits-governance__container">
          <div className="benefits-governance__header">
            <h2 className="benefits-governance__title section-title">
              Why Governance Matters
            </h2>
            <p className="section-subtitle benefits-governance__subtitle">
              Effective security governance translates technical controls into
              strategic business value, ensuring compliance, reducing risk, and
              building organizational maturity.
            </p>
          </div>
          <div className="benefits-governance__grid">
            <div className="benefits-governance__card">
              <div className="benefits-governance__icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                  className="benefits-governance__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-governance__card-title">
                Risk Reduction
              </h3>
              <p className="section-content benefits-governance__card-text">
                Identify and prioritize security risks through structured
                frameworks that map threats to business impact. Build defensible
                risk registers aligned with board-level risk appetite and
                tolerance thresholds.
              </p>
            </div>
            <div className="benefits-governance__card">
              <div className="benefits-governance__icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                  className="benefits-governance__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="m9 14l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-governance__card-title">
                Policy Automation
              </h3>
              <p className="section-content benefits-governance__card-text">
                Transform manual policy management into automated,
                version-controlled governance artifacts. Streamline policy
                lifecycle from creation through attestation, review, and
                exception handling.
              </p>
            </div>
            <div className="benefits-governance__card">
              <div className="benefits-governance__icon-wrapper">
                <svg
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                  height="32"
                  viewBox="0 0 24 24"
                  className="benefits-governance__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="benefits-governance__card-title">
                Management Maturity
              </h3>
              <p className="section-content benefits-governance__card-text">
                Advance security program maturity across people, process, and
                technology domains. Build repeatable, measurable capabilities
                that demonstrate continuous improvement to auditors and
                executives.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="challenges-governance">
        <div className="challenges-governance__container">
          <div className="challenges-governance__header">
            <h2 className="challenges-governance__title section-title">
              Common Governance Challenges
            </h2>
            <p className="section-subtitle challenges-governance__subtitle">
              Organizations face structural governance gaps that create
              compliance risks, inefficient operations, and limited executive
              visibility into security posture.
            </p>
          </div>
          <div className="challenges-governance__steps">
            <div className="challenges-governance__step">
              <div className="challenges-governance__step-indicator">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                  className="challenges-governance__step-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
                <span className="challenges-governance__step-number">01</span>
              </div>
              <div className="challenges-governance__step-content">
                <h3 className="challenges-governance__step-title">
                  Policy Gaps and Inconsistencies
                </h3>
                <p className="section-content challenges-governance__step-text">
                  Organizations operate with outdated, conflicting, or
                  incomplete policies that fail to address modern threats, cloud
                  architectures, or regulatory requirements. Policy documents
                  exist in silos without centralized version control or approval
                  workflows.
                </p>
              </div>
            </div>
            <div className="challenges-governance__step">
              <div className="challenges-governance__step-indicator">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                  className="challenges-governance__step-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
                <span className="challenges-governance__step-number">02</span>
              </div>
              <div className="challenges-governance__step-content">
                <h3 className="challenges-governance__step-title">
                  Regulatory Mapping Complexity
                </h3>
                <p className="section-content challenges-governance__step-text">
                  Multiple overlapping compliance mandates (ISO 27001, SOC 2,
                  PCI-DSS, GDPR, HIPAA) create confusion around control
                  ownership and evidence requirements. Teams struggle to
                  demonstrate how security controls satisfy multiple frameworks
                  simultaneously.
                </p>
              </div>
            </div>
            <div className="challenges-governance__step">
              <div className="challenges-governance__step-indicator">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                  className="challenges-governance__step-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
                <span className="challenges-governance__step-number">03</span>
              </div>
              <div className="challenges-governance__step-content">
                <h3 className="challenges-governance__step-title">
                  Control Design Inefficiencies
                </h3>
                <p className="section-content challenges-governance__step-text">
                  Security controls are implemented reactively without
                  architectural planning, resulting in duplicative tools, manual
                  processes, and significant operational overhead. Control
                  effectiveness cannot be measured or reported consistently.
                </p>
              </div>
            </div>
            <div className="challenges-governance__step">
              <div className="challenges-governance__step-indicator">
                <svg
                  width="28"
                  xmlns="http://www.w3.org/2000/svg"
                  height="28"
                  viewBox="0 0 24 24"
                  className="challenges-governance__step-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
                <span className="challenges-governance__step-number">04</span>
              </div>
              <div className="challenges-governance__step-content">
                <h3 className="challenges-governance__step-title">
                  Executive Communication Gaps
                </h3>
                <p className="section-content challenges-governance__step-text">
                  Security teams lack the governance structure to translate
                  technical risks into business language for executive and board
                  audiences. Risk reporting remains qualitative, inconsistent,
                  and disconnected from strategic business objectives.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="approach" className="approach-governance">
        <div className="approach-governance__container">
          <div className="approach-governance__header">
            <h2 className="section-title approach-governance__title">
              Our Structured Advisory Approach
            </h2>
            <p className="section-subtitle approach-governance__subtitle">
              A phased methodology that moves from assessment through design,
              implementation planning, and continuous improvement of your
              governance program.
            </p>
          </div>
          <div className="approach-governance__steps">
            <div className="approach-governance__step">
              <div className="approach-governance__step-visual">
                <div className="approach-governance__step-number">
                  <span>1</span>
                </div>
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                  className="approach-governance__step-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="8" y="2" rx="1" ry="1" width="8" height="4"></rect>
                    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                    <path d="m9 14l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <div className="approach-governance__step-content">
                <h3 className="approach-governance__step-title">
                  Current State Assessment
                </h3>
                <p className="section-content approach-governance__step-text">
                  Evaluate existing governance artifacts, policy inventory,
                  control frameworks, and organizational maturity. Identify gaps
                  against industry standards and regulatory baselines through
                  stakeholder interviews and documentation review.
                </p>
              </div>
            </div>
            <div className="approach-governance__step-connector"></div>
            <div className="approach-governance__step">
              <div className="approach-governance__step-visual">
                <div className="approach-governance__step-number">
                  <span>2</span>
                </div>
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                  className="approach-governance__step-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <div className="approach-governance__step-content">
                <h3 className="approach-governance__step-title">
                  Target State Definition
                </h3>
                <p className="section-content approach-governance__step-text">
                  Design future-state governance architecture aligned with
                  business strategy, risk appetite, and compliance obligations.
                  Define policy hierarchy, control catalog structure, and
                  governance operating model with clear roles and
                  responsibilities.
                </p>
              </div>
            </div>
            <div className="approach-governance__step-connector"></div>
            <div className="approach-governance__step">
              <div className="approach-governance__step-visual">
                <div className="approach-governance__step-number">
                  <span>3</span>
                </div>
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                  className="approach-governance__step-icon"
                >
                  <path
                    d="M10 6h8m-6 10h6M3 3v16a2 2 0 0 0 2 2h16M8 11h7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <div className="approach-governance__step-content">
                <h3 className="approach-governance__step-title">
                  Implementation Roadmap
                </h3>
                <p className="section-content approach-governance__step-text">
                  Build phased delivery plan with dependencies, effort
                  estimates, and resource requirements. Prioritize quick wins
                  that demonstrate value while advancing long-term program
                  maturity objectives.
                </p>
              </div>
            </div>
            <div className="approach-governance__step-connector"></div>
            <div className="approach-governance__step">
              <div className="approach-governance__step-visual">
                <div className="approach-governance__step-number">
                  <span>4</span>
                </div>
                <svg
                  width="36"
                  xmlns="http://www.w3.org/2000/svg"
                  height="36"
                  viewBox="0 0 24 24"
                  className="approach-governance__step-icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <div className="approach-governance__step-content">
                <h3 className="approach-governance__step-title">
                  Continuous Monitoring
                </h3>
                <p className="section-content approach-governance__step-text">
                  Establish metrics, KPIs, and reporting cadence for ongoing
                  governance effectiveness measurement. Implement review cycles,
                  exception management processes, and continuous improvement
                  feedback loops.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="deliverables-governance">
        <div className="deliverables-governance__container">
          <div className="deliverables-governance__header">
            <h2 className="section-title deliverables-governance__title">
              Governance Program Deliverables
            </h2>
            <p className="section-subtitle deliverables-governance__subtitle">
              Comprehensive artifacts and milestones that transform governance
              from aspirational to operational, with clear ownership and
              measurable success criteria.
            </p>
          </div>
          <div className="deliverables-governance__table-wrapper">
            <table className="deliverables-governance__table">
              <thead>
                <tr>
                  <th className="deliverables-governance__table-header">
                    <span>Deliverable Category</span>
                  </th>
                  <th className="deliverables-governance__table-header">
                    <span>Key Artifacts</span>
                  </th>
                  <th className="deliverables-governance__table-header">
                    <span>Maturity Impact</span>
                  </th>
                  <th className="deliverables-governance__table-header">
                    <span>Timeline</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="deliverables-governance__table-row">
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__category-label">
                      Policy Framework
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>
                      Information Security Policy, Acceptable Use Policy, Data
                      Classification Policy, Incident Response Policy, Change
                      Management Policy
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__maturity-badge">
                      Level 2-3
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>6-8 weeks</span>
                  </td>
                </tr>
                <tr className="deliverables-governance__table-row">
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__category-label">
                      Control Architecture
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>
                      Control Catalog (CIS, NIST, ISO-aligned), Control Matrix,
                      Ownership Assignment (RACI), Evidence Collection
                      Procedures
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__maturity-badge">
                      Level 3-4
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>4-6 weeks</span>
                  </td>
                </tr>
                <tr className="deliverables-governance__table-row">
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__category-label">
                      Risk Management
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>
                      Risk Register, Risk Assessment Methodology, Risk Appetite
                      Statement, Third-Party Risk Program, Business Impact
                      Analysis
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__maturity-badge">
                      Level 3-4
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>8-10 weeks</span>
                  </td>
                </tr>
                <tr className="deliverables-governance__table-row">
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__category-label">
                      Compliance Mapping
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>
                      ISO 27001 Statement of Applicability, SOC 2 Readiness
                      Assessment, PCI-DSS Gap Analysis, GDPR Data Flow Mapping
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__maturity-badge">
                      Level 2-3
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>4-6 weeks</span>
                  </td>
                </tr>
                <tr className="deliverables-governance__table-row">
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__category-label">
                      Operating Model
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>
                      Governance Charter, Committee Structure (Security
                      Steering, Risk Council), Meeting Cadence, Escalation
                      Procedures, Reporting Templates
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__maturity-badge">
                      Level 3-4
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>3-4 weeks</span>
                  </td>
                </tr>
                <tr className="deliverables-governance__table-row">
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__category-label">
                      Metrics Program
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>
                      Security KPI Dashboard, Control Effectiveness Metrics,
                      Program Maturity Scorecard, Executive Reporting Package,
                      Trend Analysis
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span className="deliverables-governance__maturity-badge">
                      Level 4-5
                    </span>
                  </td>
                  <td className="deliverables-governance__table-cell">
                    <span>6-8 weeks</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section className="standards-governance">
        <div className="standards-governance__container">
          <div className="standards-governance__header">
            <h2 className="standards-governance__title section-title">
              Standards &amp; Regulatory Alignment
            </h2>
            <p className="section-subtitle standards-governance__subtitle">
              Our governance advisory services map directly to recognized
              compliance frameworks and regulatory mandates, ensuring audit
              readiness and continuous compliance.
            </p>
          </div>
          <div className="standards-governance__table-wrapper">
            <table className="standards-governance__table">
              <thead>
                <tr>
                  <th className="standards-governance__table-header">
                    <span>Framework / Standard</span>
                  </th>
                  <th className="standards-governance__table-header">
                    <span>Governance Coverage</span>
                  </th>
                  <th className="standards-governance__table-header">
                    <span>Key Controls Addressed</span>
                  </th>
                  <th className="standards-governance__table-header">
                    <span>Certification Support</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="standards-governance__table-row">
                  <td className="standards-governance__table-cell">
                    <span className="standards-governance__framework-name">
                      ISO 27001:2022
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      Complete ISMS establishment, Annex A control selection,
                      Statement of Applicability, Management review processes
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      A.5 (Policies), A.6 (Organization), A.8 (Asset
                      Management), A.18 (Compliance)
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="standards-governance__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Full Certification Readiness
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </td>
                </tr>
                <tr className="standards-governance__table-row">
                  <td className="standards-governance__table-cell">
                    <span className="standards-governance__framework-name">
                      SOC 2 Type II
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      Trust Services Criteria implementation, control design
                      documentation, evidence collection procedures, continuous
                      monitoring
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      CC2 (Communication), CC3 (Risk), CC4 (Monitoring), CC5
                      (Control Activities)
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="standards-governance__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Audit Preparation
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </td>
                </tr>
                <tr className="standards-governance__table-row">
                  <td className="standards-governance__table-cell">
                    <span className="standards-governance__framework-name">
                      PCI-DSS v4.0
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      Information security policy (12.1), Risk assessment
                      (12.2), Security awareness (12.6), Incident response
                      (12.10)
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      Requirement 12 (Security Policies), Requirement 1-11
                      control mapping and ownership
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="standards-governance__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Compliance Validation
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </td>
                </tr>
                <tr className="standards-governance__table-row">
                  <td className="standards-governance__table-cell">
                    <span className="standards-governance__framework-name">
                      NIST CSF 2.0
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      GOVERN function implementation, GV.OC, GV.RM, GV.RR
                      categories, integration with IDENTIFY, PROTECT, DETECT
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      GV.OC (Oversight), GV.RM (Risk Management), GV.SC (Supply
                      Chain), GV.PO (Policy)
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="standards-governance__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Framework Adoption
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </td>
                </tr>
                <tr className="standards-governance__table-row">
                  <td className="standards-governance__table-cell">
                    <span className="standards-governance__framework-name">
                      GDPR / CCPA
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      Data protection governance, privacy by design, DPIA
                      processes, data subject rights management, breach
                      notification procedures
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      Article 24 (Controller responsibility), Article 30
                      (Records), Article 32 (Security), Article 35 (DPIA)
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="standards-governance__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Privacy Compliance
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </td>
                </tr>
                <tr className="standards-governance__table-row">
                  <td className="standards-governance__table-cell">
                    <span className="standards-governance__framework-name">
                      AI GRC Frameworks
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      AI governance charter, model risk management, algorithmic
                      accountability, ethical AI guidelines, AI incident
                      response
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <span>
                      NIST AI RMF, ISO 42001 (when published), EU AI Act
                      readiness, model inventory and lifecycle
                    </span>
                  </td>
                  <td className="standards-governance__table-cell">
                    <svg
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 0 24 24"
                      className="standards-governance__check-icon"
                    >
                      <path
                        d="M20 6L9 17l-5-5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                    <span>
                      {' '}
                      Emerging Standards
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <section id="contact" className="cta-governance">
        <div className="cta-governance__container">
          <div className="cta-governance__card">
            <div className="cta-governance__content">
              <div className="cta-governance__icon-box">
                <svg
                  width="48"
                  xmlns="http://www.w3.org/2000/svg"
                  height="48"
                  viewBox="0 0 24 24"
                  className="cta-governance__icon"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M8 2v4m8-4v4"></path>
                    <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                    <path d="M3 10h18"></path>
                  </g>
                </svg>
              </div>
              <h2 className="cta-governance__title section-title">
                Ready to Strengthen Your Governance Program?
              </h2>
              <p className="section-content cta-governance__text">
                Schedule a confidential strategy session with our governance
                specialists to assess your current maturity, identify priority
                gaps, and design a roadmap aligned with your compliance
                objectives and business strategy.
              </p>
              <div className="cyber-governance-advisory-thq-cta-governanceactions-elm cta-governance__actions">
                <a href="#schedule">
                  <div className="btn-primary btn-xl btn">
                    <span>Schedule Strategy Session</span>
                  </div>
                </a>
              </div>
            </div>
            <div className="cta-governance__image-wrapper">
              <img
                alt="Professional businesswoman in corporate meeting"
                src="https://images.pexels.com/photos/7433903/pexels-photo-7433903.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
                className="cta-governance__image"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="cyber-governance-advisory-container2">
        <div className="cyber-governance-advisory-container3">
          <Script
            html={`<script defer data-name="governance-animations">
(function(){
  const observerOptions = {
    threshold: 0.15,
    rootMargin: "0px 0px -50px 0px",
  }

  const fadeInObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = "1"
        entry.target.style.transform = "translateY(0)"
      }
    })
  }, observerOptions)

  document.querySelectorAll(".benefits-governance__card, .challenges-governance__step, .approach-governance__step, .team-governance__member").forEach((el) => {
    el.style.opacity = "0"
    el.style.transform = "translateY(20px)"
    el.style.transition = "opacity 0.5s ease, transform 0.5s ease"
    fadeInObserver.observe(el)
  })

  const heroMedia = document.querySelector(".hero-governance__media")
  if (heroMedia) {
    window.addEventListener("scroll", () => {
      const scrolled = window.pageYOffset
      const rate = scrolled * 0.3
      heroMedia.style.transform = \`translateY(\${rate}px)\`
    })
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default CyberGovernanceAdvisory
